import { render, staticRenderFns } from "./CategoryButtons.vue?vue&type=template&id=226cbe28&scoped=true&"
import script from "./CategoryButtons.vue?vue&type=script&lang=js&"
export * from "./CategoryButtons.vue?vue&type=script&lang=js&"
import style0 from "./CategoryButtons.vue?vue&type=style&index=0&id=226cbe28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cbe28",
  null
  
)

export default component.exports